import { toast } from 'react-toastify';

import CarbonToast from '../components/ToastComponent';

const error = (msg) => {
  if (msg.indexOf('Two-Factor authentication is required') > -1) return;
  if (toast.isActive(msg)) return;
  return toast(<CarbonToast variant={'error'} message={msg} />, { autoClose: 15000, toastId: msg });
};

const info = (msg) => {
  if (toast.isActive(msg)) return;
  return toast(<CarbonToast variant={'info'} message={msg} />, { autoClose: 7000, toastId: msg });
};

const success = (msg) => {
  if (toast.isActive(msg)) return;
  return toast(<CarbonToast variant={'success'} message={msg} />, { autoClose: 5000, toastId: msg });
};

const warning = (msg) => {
  if (toast.isActive(msg)) return;
  return toast(<CarbonToast variant={'warning'} message={msg} />, { autoClose: 10000, toastId: msg });
};

const toastr = {
  error,
  info,
  success,
  warning,
};

export default toastr;
